import { getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import { spacing } from 'ext-ui/style/spacing'
import { transition_slow } from 'ext-ui/style/transitionSpeeds'
import variables from 'src/style/variables.json'
import { css } from 'styled-components'

export default css`
  &.CreditCardDropdownHandle {
    & .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-grow: 2;
      height: 38px;
      padding: ${spacing(2)} ${spacing(4)};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }

    & .content {
      display: flex;
      align-items: center;
    }

    & .icon {
      margin-left: 4px;
      transition: transform ${transition_slow};
      transform: rotate(180deg);
      &.open {
        transform: rotate(0deg);
      }
    }

    & .value {
      overflow: hidden;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      ${getFontCss(
        14,
        themeConstants.colors.cta,
        styleConstants.fontFamilies.medium,
      )};
      margin-right: 4px;
    }

    & .genericCardIcon {
      max-width: ${variables.units['base-unit-5']}px;
      max-height: ${variables.units['base-unit-5']}px;
      margin-right: ${variables.units['base-unit-2']}px;
    }

    & .cardStack {
      position: relative;
      height: 18px;
      margin-right: ${variables.units['base-unit-1']}px;
    }

    & .cardStack:has(> img:nth-child(2)) {
        min-width: 26px;
    }

    & .cardStack > img + img {
      border: 0.25px solid white;
    }

    & .cardIcon {
      width: 18px;

      &.source {
        border-radius: 3.37%/5.92%;
      }

      &.offset {
        position: absolute;
        top: 2px;
        left: 8px;
      }
    }
`
